import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ReferenceDatum } from '@sondermind/data-access/reference-data';

export enum RefDatumOrder {
  column = 'column',
  row = 'row'
}

@Component({
  selector: 'sondermind-reference-datum-checklist',
  templateUrl: './reference-datum-checklist.component.html',
  styleUrls: [
    './reference-datum-checklist.component.scss'
  ],
  standalone: false
})

export class ReferenceDatumChecklistComponent implements OnChanges {
  readonly ROW_HEIGHT: number = 80;
  ulHeight: number;

  @Input() form: UntypedFormGroup;
  @Input() refDatumItems: ReferenceDatum[];
  @Input() columns: number = 3;
  @Input() order: RefDatumOrder = RefDatumOrder.column;
  @Input() isDisabled = false;

  refDatumOrder = RefDatumOrder;

  ngOnChanges(changes: SimpleChanges) {
    if (this.refDatumItems && this.order === this.refDatumOrder.column) {
      this.ulHeight = Math.ceil(this.refDatumItems.length / this.columns) * this.ROW_HEIGHT;
    }

    if (changes['isDisabled']) {
      Object.keys(this.form.controls).forEach((key) => {
        if (this.isDisabled) {
          this.form.controls[key].disable();
        } else {
          this.form.controls[key].enable();
        }
      });
    }
  }

  onSelectionChange(event: any): void {
    event.options.forEach((option: any) => {
      this.form.get(option.value)?.setValue(option.selected);
    });
  }
}
